import { getTextValueOrUndefined } from '@anu/utilities/fields';
import PropTypes from 'prop-types';

const transformConditions = (paragraph) => {
  // Each paragraph is a state.
  const state = { questions: [] };

  try {
    // Parse JSON string.
    const value = getTextValueOrUndefined(paragraph, 'field_state_conditions');
    const questions = JSON.parse(value);

    // Parse questions and give them better structure.
    state.questions = Object.keys(questions)
      .map(aqid => ({
        aqid,
        ...questions[aqid]
      }));
  } catch (e) {
  }

  return state;
};

/**
 * Define expected prop types for lesson.
 */
const conditionPropTypes = PropTypes.shape({
  states: PropTypes.arrayOf(
    PropTypes.shape({
      questions: PropTypes.arrayOf(
        PropTypes.shape({
          aqid: PropTypes.string.isRequired,
          answers: PropTypes.arrayOf(
            PropTypes.string
          ).isRequired,
          exact: PropTypes.bool,
        })
      ).isRequired,
    })
  ),
});

export { transformConditions, conditionPropTypes };
